//import {Dimensions} from 'react-native';
import {isDesktop} from 'react-device-detect';
import {Platform} from 'react-native';

export function isWebDesktopView() {
  var OS = Platform.OS.toLowerCase();
  if (OS === 'android' || OS === 'ios') {
    return false;
  }
  if (OS === 'web' && !isDesktop) {
    return false;
  }

  return true;
}
